
import { Component, Vue } from "vue-property-decorator";
import { getFlagCode } from "../utils/languageUtils";

@Component({ inheritAttrs: false })
export default class LanguageDropdown extends Vue {
  flagCode(code: string): string {
    return getFlagCode(code);
  }
}
